import { ComplainantGeneral } from "../Model/ComplainantGeneral";
import { Query } from "../Model/Query";
import { Third } from "../Model/Third";
import { getCurrentUser } from "./session";
import { v4 as v4uuid } from "uuid";
export class ComplainantGeneralService {
    constructor(apiService, queryParamsFactory) {
        this.apiService = apiService;
        this.queryParamsFactory = queryParamsFactory;
    }
    async findOne(thirdId, diligenceId) {
        if (diligenceId) {
            const response = await this.apiService.get('complainant_general/' + diligenceId + '/third_id/' + thirdId);
            if (!response.ok) {
                throw new Error(`Error al obtener`);
            }
            const content = await response.json();
            if (content) {
                return content;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener ComplainantId`);
        }
    }
    async findByDiligenceNumber(diligenceId) {
        if (diligenceId) {
            const response = await this.apiService.get('complainant_general/' + diligenceId);
            if (!response.ok) {
                throw new Error(`Error al obtener`);
            }
            const content = await response.json();
            if (content) {
                return content;
            }
            return;
        }
        else {
            throw new Error(`Error al obtener ComplainantId`);
        }
    }
    async findThirds(opts) {
        var _a, _b;
        if (((opts === null || opts === void 0 ? void 0 : opts.offset) || opts.offset >= 0) && (opts === null || opts === void 0 ? void 0 : opts.limit)) {
            const query = new Query(opts.offset, opts.limit);
            if ((_a = opts.filters) === null || _a === void 0 ? void 0 : _a.diligenceId) {
                query.addFilter('diligence_id', [opts.filters.diligenceId]);
            }
            if ((_b = opts.filters) === null || _b === void 0 ? void 0 : _b.thirdId) {
                query.addFilter('third_id', [opts.filters.thirdId]);
            }
            const params = this.queryParamsFactory.createQueryParams(query);
            const response = await this.apiService.get(`complainants_general/generalThirds?${params}`);
            if (!response.ok) {
                throw new Error(`Error al obtener los terceros.`);
            }
            const content = await response.json();
            return content.map(third => new Third(third).getState());
        }
        else {
            throw new Error(`Error al obtener opts.`);
        }
    }
    async createComplainantGeneral(thirdId, diligenceId) {
        if (thirdId && diligenceId) {
            const third = new ComplainantGeneral({
                id: v4uuid(),
                diligenceNumber: diligenceId,
                complainantThirId: thirdId,
                showPartCause: false,
                resignationRestitutionCause: false,
                resignationRepairDamage: false,
                indemnificationWaiver: false,
                appointsLawyer: false,
                freeJustice: false,
                vehicleId: null,
                lawyerPart: " ",
                suspectSomeone: false,
                denouncePreviously: false,
                userId: getCurrentUser().id,
                vehicleDamage: " ",
                trailerPlate: " ",
                ownsSecurity: false,
                drivingLicense: false,
                licenseExpiration: null
            });
            const response = await this.apiService.post('complainant_general', third.getState());
            if (!response.ok) {
                throw new Error(`Error al guardar el denunciante de una diligencia trafico`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener el denunciante`);
        }
    }
    async saveComplainantGeneral(complainantGeneral) {
        console.log(complainantGeneral);
        const response = await this.apiService.post('complainant_general', complainantGeneral);
        if (!response.ok) {
            throw new Error(`Error al guardar el extra de diligencia trafico`);
        }
        return true;
    }
    async deleteComplainantGeneral(thirdId) {
        if (thirdId) {
            const response = await this.apiService.post('complainants_general/delete', { id: thirdId });
            if (!response.ok) {
                throw new Error(`Error al eliminar el denunciante de una diligencia general.`);
            }
            return true;
        }
        else {
            throw new Error(`Error al obtener el denunciante.`);
        }
    }
}
